import React from 'react';
import PropTypes, { any } from 'prop-types';
import styles from './dropdownCheckBoxFilter.scss';

const DropdownCheckBoxFilter = (props) => {
    const { options = [], filterInputs, filterInputName, onChange, isArray, isDivision, 'data-testid': dataTestId } = props;
    const createCheckbox = option => {
        const { label, value, count } = option;
        return (
            <div className="col-12 d-flex jcc aib" key={value}>
                <input
                    type="checkbox"
                    name={value}
                    id={value}
                    className="standalone-checkbox"
                    checked={isArray ? filterInputs[filterInputName]?.includes(value) : filterInputs[filterInputName][value]}
                    onChange={() => onChange(value)}
                    data-testid={dataTestId && `${dataTestId}.option-${value}.checkbox`}
                />
                <label htmlFor={value}><span /></label>
                <label htmlFor={value} className={styles.name} data-testid={dataTestId && `${dataTestId}.option-${value}.label`}>{label}</label>
                <p className="flex-right" data-testid={dataTestId && `${dataTestId}.option-${value}.count`}>{isDivision ? count : ''}</p>
            </div>
        );
    };

    return (
        <div className="row" data-testid={dataTestId}>
            {options.map(option => createCheckbox(option))}
        </div>
    );
};

DropdownCheckBoxFilter.propTypes = {
    isArray: PropTypes.bool,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterInputName: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(any).isRequired,
    isDivision: PropTypes.bool,
    'data-testid': PropTypes.string,
};

DropdownCheckBoxFilter.defaultProps = {
    isArray: false,
    isDivision: false,
    'data-testid': undefined,
};

export default DropdownCheckBoxFilter;
